/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const listenToNodeMessages = /* GraphQL */ `
  subscription ListenToNodeMessages($nodeId: String!) {
    listenToNodeMessages(nodeId: $nodeId) {
      internalNodeId
      message
    }
  }
`;
export const listenToNodeFiles = /* GraphQL */ `
  subscription ListenToNodeFiles($nodeId: String!) {
    listenToNodeFiles(nodeId: $nodeId) {
      internalNodeId
      downloadURL
      file
    }
  }
`;
export const listenToDeviceData = /* GraphQL */ `
  subscription ListenToDeviceData($customerId: String!) {
    listenToDeviceData(customerId: $customerId) {
      customerId
      locationId
      locationName
      id
      name
      status
      nodeId
      nodeName
      makeModelId
      cameraIpAddress
      deviceData {
        hasPanTilt
        hasRecordVideo
        hasZoom
        keyFrame
        panTiltIP
        panTiltType
        protocol
        recentFrame
        rtspHost
        sourceVideo
        signedUrlKeyFrame
        signedUrlRecentFrame
      }
      currentPosition {
        pan
        tilt
        zoom
      }
      healthData {
        isOnline
        lastAlive
      }
    }
  }
`;
export const listenToServiceHealthData = /* GraphQL */ `
  subscription ListenToServiceHealthData($customerId: String!) {
    listenToServiceHealthData(customerId: $customerId) {
      nodeId
      customerId
      locationId
      deviceId
      serviceType
      configuration
      id
      healthData
      isRunning
    }
  }
`;
export const listenToEdgeClientMessage = /* GraphQL */ `
  subscription ListenToEdgeClientMessage($id: String) {
    listenToEdgeClientMessage(id: $id) {
      id
      statusCode
      topic
      payload
      payloadType
      timestamp
    }
  }
`;
export const listenToUpdateZone = /* GraphQL */ `
  subscription ListenToUpdateZone($id: String) {
    listenToUpdateZone(id: $id) {
      id
      name
      pan
      tilt
      deviceId
      status
      serviceId
      inspectTime
      keyFrame
      threshold {
        id
        name
        value
      }
      exclusions
      nodeId
      alertData
      zoom
      shouldNotify
      focusMode
      focusDistance
      signedUrlKeyFrame
    }
  }
`;
export const listenToDeleteZone = /* GraphQL */ `
  subscription ListenToDeleteZone($id: String) {
    listenToDeleteZone(id: $id) {
      id
      name
      pan
      tilt
      deviceId
      status
      serviceId
      inspectTime
      keyFrame
      threshold {
        id
        name
        value
      }
      exclusions
      nodeId
      alertData
      zoom
      shouldNotify
      focusMode
      focusDistance
      signedUrlKeyFrame
    }
  }
`;
export const listenToAddZone = /* GraphQL */ `
  subscription ListenToAddZone($customerId: String) {
    listenToAddZone(customerId: $customerId) {
      id
      name
      pan
      tilt
      deviceId
      status
      serviceId
      inspectTime
      keyFrame
      threshold {
        id
        name
        value
      }
      exclusions
      nodeId
      alertData
      zoom
      shouldNotify
      focusMode
      focusDistance
      signedUrlKeyFrame
    }
  }
`;
export const listenToNodeOnlineStatus = /* GraphQL */ `
  subscription ListenToNodeOnlineStatus($customerId: String!) {
    listenToNodeOnlineStatus(customerId: $customerId) {
      customerId
      locationId
      id
      nodeName
      nodeId
      level
      referenceId
      devices {
        customerId
        locationId
        locationName
        id
        name
        status
        nodeId
        nodeName
        makeModelId
        cameraIpAddress
        deviceData {
          hasPanTilt
          hasRecordVideo
          hasZoom
          keyFrame
          panTiltIP
          panTiltType
          protocol
          recentFrame
          rtspHost
          sourceVideo
          signedUrlKeyFrame
          signedUrlRecentFrame
        }
        currentPosition {
          pan
          tilt
          zoom
        }
        healthData {
          lastAlive
          isOnline
        }
        skuNumber
        serialNumber
        componentSerialNumber
        onboardedAt
        parentProductSerialNumber
      }
      serviceData
      deviceData
      onboardCommand
      tags {
        id
        tagName
      }
      nodeIP
      isOnline
      skuNumber
      serialNumber
      componentSerialNumber
      onboardedAt
    }
  }
`;
export const listenToHumanValidationEvents = /* GraphQL */ `
  subscription ListenToHumanValidationEvents {
    listenToHumanValidationEvents {
      id
      customerId
      locationId
      nodeId
      serviceId
      data
      validationState
      validated_by
      explanation
      eventTime
      audited_by
      transitionInfo
      auditorsExplanation
    }
  }
`;
export const listenToLoaderProgress = /* GraphQL */ `
  subscription ListenToLoaderProgress($jobId: String!) {
    listenToLoaderProgress(jobId: $jobId) {
      jobId
      percent
      page
      rowsTotal
      message
    }
  }
`;
